<template>
  <!-- 智慧园区 -->
  <div class="scheme_container">
    <div class="scheme_wrap">
      <div class="title_wrap">{{pageData.title}}</div>
      <div class="content_wrap">
        <div class="article_box unify_article">{{pageData.text.text1}}</div>
        <div class="img_wrap" v-for=" (item, index) in pageData.imgArr" :key="index">
          <img :src="item.imgSrc" :alt="item.alt">
        </div>
        &nbsp;
        <div class="article_wrap">
          <p class="subtitle">{{pageData.text.text2.textTitle}}</p>
          <div class="text unify_article">{{pageData.text.text2.textContent}}</div>
        </div>
        &nbsp;
         <div class="article_wrap">
          <p class="subtitle">{{pageData.text.text3.textTitle}}</p>
          <div class="text unify_article" v-for="(item, index) in pageData.text.text3.textContent" :key="index">{{item}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageData: {
          title: '智慧园区',
          text: {
            text1: '瑞谦智慧园区解决方案以“以人为本，绿色高效，业务增值”的目标，利用物联网、大数据、人工智能等技术，搭建一体可视化综合管理平台，打破“信息孤岛”，实现人机事物深度融合互通，打造“安全、智慧、高效、绿色”的园区，满足政府管理部门、园区管理者、入驻企业、员工不同需求，大幅提升园区的管理和服务能力，提升园区的社会和经济价值。',
            text2: {
              textTitle: '实现全方面安全防控',
              textContent: '通过运用人员身份识别、 VIP迎宾服务、访客登记、陌生人提醒、黑名单人员警示、车牌识别控制等技术建设可视化综合管理平台，实现设备可视、事件可控、人员可管，提升园区管理服务水平。'
            },
            text3: {
              textTitle: '带来共赢的实际收益',
              textContent: [
                '建立虚拟园区平台，整合园区及周边的各类民生资源查询周边美食、娱乐、医疗等，提高员工幸福感。',
                '有效整合园区产业链资源，实现园区企业之间的信息互通，园区企业可以享受更便捷高效的政务服务和商业服务，提高企业办公效率、降低企业运营成本、提升企业竞争力。',
                '针对园区、企业的能源消耗和节能控制需求，通过智能照明管理、空调节能自控和节水控制等系统应急管理，对园区内的各类突发事件进行监测、预警、判断，能够更准确发现异常，更快速下达决策、调度和处置。'
              ]
            },
          },
          imgArr: [
            {
              imgSrc: require('@/assets/img/solution/pageImg/1.jpg'),
              alt: ''
            }
          ]
        }
      }
    }

  }
</script>

<style scoped lang="scss">
@import "@/views/solution/unifyStyle";
</style>
